
import React, { memo } from 'react';
import SVG from "react-inlinesvg";
import styles from '../../customDialogUploadFile.module.scss';
import { useTranslation } from 'react-i18next';

const ImagesWithDescription = ({ image, description, typesFile, maxWidth, maxHeigth }) => {
    const { t } = useTranslation('home');

    return (
        <div className={styles.content}>
            <SVG src={image} />
            <span className={styles.description}>
                {
                    `${t(description)
                        .replace('[FILE_TYPE]', String(typesFile).toUpperCase())
                        .replace('[WIDTH]', maxWidth)
                        .replace('[HEIGTH]', maxHeigth)
                    }.`
                }
            </span>
        </div>
    )
}

export default memo(ImagesWithDescription);